import { all, call, put, takeLatest } from 'redux-saga/effects';

import { push } from 'react-router-redux';
import { normalize } from 'normalizr';
import merge from 'lodash/merge';

import { setAuthHeaders } from 'helpers/auth';
import libApi from 'helpers/api';

import {
  AUTH_REQUEST,
  LOGIN_REQUEST,
  FORGOT_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST,
  LOGOUT,
  authSuccess,
  authFailure,
  loginSuccess,
  loginFailure,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  resetPasswordSuccess,
  resetPasswordFailure
} from 'store/auth/actions';

import * as api from 'api';
import * as schemas from 'schemas';

import { fetchCustomerEntities } from '../customers/sagas';

function* fetchMyUser() {
  const user = yield call(api.fetchMyUser);

  return normalize(user, schemas.user);
}

function* fetchMyCustomers() {
  const customers = yield all([
    call(api.fetchCustomer, 1),
    call(api.fetchCustomer, 2)
  ]);

  return normalize(customers, [schemas.customer]);
}

function* fetchMyData() {
  const [responseUser, responseCustomers] = yield all([
    call(fetchMyUser),
    call(fetchMyCustomers)
  ]);

  const response = {
    entities: merge({}, responseUser.entities, responseCustomers.entities),
    userId: responseUser.result,
    customerIds: responseCustomers.result
  };

  return response;
}

function* handleAuthRequest() {
  try {
    yield call(api.authenticate);

    const responseMyData = yield call(fetchMyData);

    let activeCustomerId = localStorage.getItem('activeCustomerId');

    if (!activeCustomerId) {
      if (responseMyData.customerIds.length === 1) {
        activeCustomerId = responseMyData.customerIds[0];
      }
    }

    const response = {
      ...responseMyData,
      activeCustomerId,
      referralCouponId: null
    };

    if (activeCustomerId) {
      yield call(fetchCustomerEntities);
    }

    yield put(authSuccess(response));
  } catch (err) {
    yield put(authFailure(err));
  }
}

function* loginApi(email, password) {
  const response = yield call(libApi.backend.post, 'auth/sign_in', {
    email,
    password
  });

  setAuthHeaders(response.headers);

  return response;
}

function* handleLoginRequest(action) {
  const { email, password } = action.payload;

  try {
    yield call(loginApi, email, password);

    const responseMyData = yield call(fetchMyData);

    const activeCustomerId =
      responseMyData.customerIds.length > 1
        ? null
        : responseMyData.customerIds[0];

    const response = {
      ...responseMyData,
      activeCustomerId,
      referralCouponId: null
    };

    if (activeCustomerId) {
      yield call(fetchCustomerEntities);
    }

    yield put(loginSuccess(response));
  } catch (err) {
    yield put(loginFailure(err));
  }
}

function* forgotPassword(action) {
  const { email } = action.payload;

  try {
    yield call(libApi.backend.post, 'auth/password', {
      email,
      redirect_url: `${window.location.origin}/reset-password`
    });

    yield put(forgotPasswordSuccess());
  } catch (err) {
    yield put(forgotPasswordFailure(err));
  }
}

function* resetPassword(action) {
  const { password, passwordConfirmation, client, token, uid } = action.payload;

  try {
    yield call(
      libApi.backend.put,
      'auth/password',
      {
        password,
        passwordConfirmation
      },
      {
        headers: {
          'access-token': token,
          client,
          uid
        }
      }
    );

    yield put(resetPasswordSuccess());
  } catch (err) {
    yield put(resetPasswordFailure(err));
  }
}

function* logout() {
  yield localStorage.removeItem('activeCustomerId');

  yield call(api.logout);
  yield put(push('/'));
}

export default function* authSaga() {
  yield all([
    takeLatest(AUTH_REQUEST, handleAuthRequest),
    takeLatest(LOGIN_REQUEST, handleLoginRequest),
    takeLatest(FORGOT_PASSWORD_REQUEST, forgotPassword),
    takeLatest(RESET_PASSWORD_REQUEST, resetPassword),
    takeLatest(LOGOUT, logout)
  ]);
}



// WEBPACK FOOTER //
// ./src/store/auth/sagas.js